module.exports = __webpack_public_path__ + "static/media/6 1 mayan warrior mayan calendar aztec .1280x1706.167e0513.webp";